
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class ExpireBishanPop extends Vue {
  get PageStore() {
    return this.$store.$myV2.Account.BiShan
  }

  handleClosePop() {
    this.PageStore.hasReadTooltip()
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
